import React from 'react';

interface ToolExplanationProps {
  title: string;
  whatIsThis: string;
  howToUse: string;
  example: string;
}

const ToolExplanation: React.FC<ToolExplanationProps> = ({ title, whatIsThis, howToUse, example }) => {
  return (
    <div
      className="mt-6 p-4 border"
      style={{ background: 'var(--elev)', borderColor: 'var(--hair)', borderRadius: 10, color: 'var(--txt-2)' }}
    >
      <h4 className="mb-2" style={{ fontSize: 14, fontWeight: 600, color: 'var(--txt)' }}>{title}</h4>
      <div className="space-y-3 leading-relaxed" style={{ fontSize: 13 }}>
        <div>
          <span className="font-semibold" style={{ color: 'var(--txt)' }}>What is this?</span>
          <p>{whatIsThis}</p>
        </div>
        <div>
          <span className="font-semibold" style={{ color: 'var(--txt)' }}>How do we use this?</span>
          <p>{howToUse}</p>
        </div>
        <div>
          <span className="font-semibold" style={{ color: 'var(--txt)' }}>Example</span>
          <p>{example}</p>
        </div>
      </div>
    </div>
  );
};

export default ToolExplanation; 